<script></script>

<template>
  <div
    class="flex bg-dot-pattern bg-dots-24 h-full w-full bg-neutral-50 rounded-tl-[40px] rounded-bl-[40px] justify-center items-center"
  >
    <div
      class="flex w-[502px] h-[217px] p-[1px] bg-[linear-gradient(111.13deg,#0800EF_-7.61%,#9F13E0_47.41%,#369EFF_103.5%)]"
    >
      <div class="flex w-full h-full bg-[#E9E3FE] overflow-hidden"></div>
    </div>
  </div>
</template>
